<template>
    <div id="selectTyresCarousel" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-indicators">
            <div class="bg-white p-1 px-2">
                <button
                    v-for="(banner, key) in sortedBanners"
                    type="button"
                    data-bs-target="#selectTyresCarousel"
                    :data-bs-slide-to="key"
                    :class="key == 0 ? 'active' : ''"
                    :aria-current="key == 0 ? 'true' : ''"
                    :aria-label="key"
                ></button>
            </div>
        </div>
        <div class="carousel-inner">
            <div class="carousel-item" :class="key == 0 ? 'active' : ''" v-for="(banner, key) in sortedBanners">
                <div class="d-none d-md-block background" :style="getDesktopBackgroundStyle(banner)">
                    <div class="banner-content">
                        <div class="col-12" :class="banner.dark_desktop_banner == 1 ? 'text-light' : 'text-dark'">
                            <div class="p-4" v-html="banner.content"></div>
                        </div>
                    </div>
                </div>
                <div class="d-block d-md-none background" :style="getMobileBackgroundStyle(banner)">
                    <div class="banner-content">
                        <div class="col-12" :class="banner.dark_mobile_banner == 1 ? 'text-light' : 'text-dark'">
                            <div class="p-4" v-html="banner.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['banners', 'page'],
        methods: {
            getDesktopBackgroundStyle(banner) {
                let imageUrl = banner.select_tyres_image_url != '' ? banner.select_tyres_image_url : '';
                return "background: url(" + imageUrl + ") no-repeat; height: auto; background-position: center 0; background-size: cover;";
            },
            getMobileBackgroundStyle(banner) {
                let imageUrl = banner.select_tyres_mobile_image_url != '' ? banner.select_tyres_mobile_image_url : '';
                return "background: url(" + imageUrl + ") no-repeat; height: auto; background-position: center; background-size: cover;";
            }
        },
        computed: {
            sortedBanners() {
                if(this.banners) {
                    let filteredBanners = this.banners?.filter(banner => banner.content != '');
                    return _orderBy(filteredBanners, 'carousel_sort_order', 'asc');
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    a {
        text-decoration: none;
    }
    @media screen and (min-width: 1200px) {
        .banner-html {
            min-height: 318px;
        }
    }
</style>